import { render, staticRenderFns } from "./UploadImageDialog.vue?vue&type=template&id=08104c1d&scoped=true"
import script from "./UploadImageDialog.vue?vue&type=script&lang=js"
export * from "./UploadImageDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadImageDialog.vue?vue&type=style&index=0&id=08104c1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08104c1d",
  null
  
)

export default component.exports